interface DateObject {
    [key: string]: string | undefined;
}

export const isDateString = (str: string) => {
    // Matches YYYY-MM-DD or YYYY-MM-DDTHH:mm:ss.sssZ
    return /^\d{4}-\d{2}-\d{2}(T.*)?$/.test(str);
  };

export default function formatDate(dateToFormat: string | undefined): string {
    if (!dateToFormat) return 'N/A';
    const date = new Date(dateToFormat);
    return `${date.getUTCMonth() + 1}/${date.getUTCDate()}/${date.getUTCFullYear()}`;
}

export const formatDates = (dates: DateObject = {}): DateObject => {
    const dateKeys = Object.keys(dates);

    if (dateKeys.length) {
        return dateKeys.reduce<DateObject>((acc, key) => {
            acc[key] = formatDate(dates[key]);
            return acc;
        }, {});
    }
    return {};
};

export function getYearFromDate(dateToParse: string): string {
    const date = new Date(dateToParse);
    return `${date.getUTCFullYear()}`;
}

export function getMinutesFromDate(dateToParse: string): number {
    const currentdate = new Date();
    const fromDate = new Date(dateToParse);
    const diffMs = fromDate.getTime() - currentdate.getTime(); // milliseconds between now and fromDate
    const minutes = Math.floor(diffMs / 1000 / 60);
    return minutes;
}

export const MMDDYY = (dateString: string): string => {
    const date: Date = new Date(dateString);
    const month: string = (date.getMonth() + 1).toString().padStart(2, '0');
    const day: string = date.getDate().toString().padStart(2, '0');
    const year: string = date.getFullYear().toString().slice(-2);
    return `${month}/${day}/${year}`;
};

export const YYYYMMDD = (): string => {
    const date = new Date();
    const formattedDate = date.toISOString().split('T')[0];
    return formattedDate;
};
